import { render, staticRenderFns } from "./DefaultAdBlock.vue?vue&type=template&id=c043bb90"
import script from "./DefaultAdBlock.vue?vue&type=script&lang=js"
export * from "./DefaultAdBlock.vue?vue&type=script&lang=js"
import style0 from "./DefaultAdBlock.vue?vue&type=style&index=0&id=c043bb90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports